import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const AccountProfile = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default AccountProfile;
